import { render, staticRenderFns } from "./DataSelectionTable.vue?vue&type=template&id=65987c57"
import script from "./DataSelectionTable.vue?vue&type=script&lang=js"
export * from "./DataSelectionTable.vue?vue&type=script&lang=js"
import style0 from "./DataSelectionTable.vue?vue&type=style&index=0&id=65987c57&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports